import { takeLatest, put, call } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import * as campaignDetailsActions from "../actions/account_campaign_actions";
import * as campaignTypes from "../types/account_campaign_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";
import { endpoints } from "../endpoints";

function* getListOfCampaign(action) {
  try {
    const res = yield call(api.get, `${endpoints.CAMPAIGN_LIST}/${action.payload.accountId}`, action.payload.query);
    if (res.status === 200) {
      yield put(campaignDetailsActions.getCampaignListSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(campaignDetailsActions.getCampaignListError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(campaignDetailsActions.getCampaignListError(e));
  }
}

function* getEmailDetailedAnalytics(action) {
  try {
    const res = yield call(api.get, `${endpoints.EMAIL_DETAILED_ANALYTICS_REPORT}/${action.payload.accountId}/${action.payload.campaignId}`, action.payload.query);
    if (res.status === 200) {
      yield put(campaignDetailsActions.getEmailCampaignAnalyticsSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(campaignDetailsActions.getEmailCampaignAnalyticsError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(campaignDetailsActions.getEmailCampaignAnalyticsError(e));
  }
}

function* getEmailDetailedReport(action) {
  try {
    const res = yield call(api.get, `${endpoints.EMAIL_DETAILED_REPORT}/${action.payload.accountId}/${action.payload.campaignId}`, action.payload.query);
    if (res.status === 200) {
      yield put(campaignDetailsActions.getEmailCampaignDetailedReportSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(campaignDetailsActions.getEmailCampaignDetailedReportError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(campaignDetailsActions.getEmailCampaignDetailedReportError(e));
  }
}

export default function* campaignDetailsSaga() {
  yield takeLatest(campaignTypes.getCampaignList.GET_CAMPAIGN_LIST_REQUEST, getListOfCampaign);
  yield takeLatest(campaignTypes.getCampaignList.GET_CAMPAIGN_LIST_REQUEST_AFTER, getListOfCampaign);
  yield takeLatest(campaignTypes.getEmailCampaignAnalytics.GET_EMAIL_CAMPAIGN_ANALYTICS_REQUEST, getEmailDetailedAnalytics);
  yield takeLatest(campaignTypes.getEmailCampaignDetailedReport.GET_EMAIL_CAMPAIGN_DETAILED_REPORT_REQUEST, getEmailDetailedReport);
}
